/**
 * AnimationManager simple pour World of Numeric - Animations subtiles
 */

export class AnimationManager {
  static init(): void {
    this.setupScrollAnimations();
    this.setupHoverEffects();
    this.setupFormInteractions();
    console.log('✨ Animations subtiles activées');
  }

  private static setupScrollAnimations(): void {
    // Observer pour les animations au scroll
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '50px'
    });

    // Ajouter l'animation aux éléments principaux
    const elementsToAnimate = [
      'section',
      '.card',
      '.service-item',
      '.formation-item'
    ];

    elementsToAnimate.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        el.classList.add('fade-in-up');
        observer.observe(el);
      });
    });
  }

  private static setupHoverEffects(): void {
    const interactiveElements = document.querySelectorAll<HTMLElement>('button, .btn, a.button');
    interactiveElements.forEach(element => {
      element.classList.add('interaction-smooth');
    });

    const cards = document.querySelectorAll<HTMLElement>('.card, .service-card, .formation-card');
    cards.forEach(card => {
      card.classList.add('card-hover-smooth');
    });
  }

  private static setupFormInteractions(): void {
    // Animation sur focus des inputs
    document.querySelectorAll('input, textarea').forEach(input => {
      input.addEventListener('focus', () => {
        (input as HTMLElement).style.transform = 'scale(1.02)';
        (input as HTMLElement).style.borderColor = '#3498db';
      });
      
      input.addEventListener('blur', () => {
        (input as HTMLElement).style.transform = 'scale(1)';
        (input as HTMLElement).style.borderColor = '';
      });
    });
  }
}

// Styles CSS pour les animations
const style = document.createElement('style');
style.textContent = `
  /* Animation de base */
  .fade-in-up {
    opacity: 0;
    transform: translateY(20px);
    transition: all 0.6s ease-out;
  }

  .fade-in-up.animate-in {
    opacity: 1;
    transform: translateY(0);
  }

  /* Transitions sur les éléments interactifs */
  .interaction-smooth {
    transition: transform 0.35s ease, box-shadow 0.35s ease, background-color 0.35s ease, color 0.35s ease !important;
    will-change: transform, box-shadow;
  }

  .card-hover-smooth {
    transition: transform 0.4s ease, box-shadow 0.4s ease !important;
    will-change: transform, box-shadow;
  }

  input, textarea {
    transition: all 0.3s ease !important;
  }

  /* Respect des préférences de mouvement réduit */
  @media (prefers-reduced-motion: reduce) {
    .fade-in-up,
    button, .btn, a.button,
    .card, .service-card, .formation-card,
    input, textarea {
      transition: none !important;
      animation: none !important;
    }
    
    .fade-in-up {
      opacity: 1;
      transform: none;
    }
  }

  /* Animation smooth pour les liens internes */
  html {
    scroll-behavior: smooth;
  }

  /* Micro-animations pour les icônes */
  .icon, svg {
    transition: transform 0.3s ease;
  }

  .icon:hover, svg:hover {
    transform: scale(1.1);
  }
`;
document.head.appendChild(style);

export default AnimationManager;
